import videojs from 'video.js';

/**
 * Check if the browser supports native HLS playback.
 *
 * @returns {boolean}
 */
export function supportsNativeHls() {
  return videojs.browser.IS_ANY_SAFARI || (videojs.browser.IS_IOS && videojs.browser.IS_CHROME);
}
